export var getFormattedCounterText = function getFormattedCounterText(currentLength, maxLength) {
  var maxLengthFormatted = (maxLength || '') && "/".concat(maxLength);
  return "".concat(currentLength).concat(maxLengthFormatted);
};